import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Booking } from '../../core/models/booking.model';
import { UtilityService } from '../../core/services/utility.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-modal-tracking-regularizacion',
  templateUrl: './modal-tracking-regularizacion.component.html',
  styleUrls: ['./modal-tracking-regularizacion.component.scss']
})
export class ModalTrackingRegularizacionComponent implements OnInit {

  @Input() bookingdamId!: any;

  CDN_BASE = environment.CDN_BASE;
  HTTP_RESPONSE = environment.HTTP_RESPONSE;

  public isLoading = true;
  public hasError = false;
  public damTracking: any = null;

  constructor(
    public activeModal: NgbActiveModal,
    private booking: Booking,
    public utilityService: UtilityService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.cargarTracking();
  }

  private async cargarTracking(): Promise<void> {
    this.isLoading = true;
    this.hasError = false;
    try {
      const response: any = await this.booking.getTrackingDamByID(this.bookingdamId);
      if (response?.tipo === this.HTTP_RESPONSE.SUCCESS) {
        this.damTracking = response.data;
      } else {
        this.hasError = true;
      }
    } catch {
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  public recargar(): void {
    this.cargarTracking();
  }

  /** Convierte valor KPI a clase de color Bootstrap */
  public kpiClass(kpi: any): string {
    if (kpi == null) return 'text-muted';
    const v = kpi * 1;
    if (v <= 1) return 'text-success';
    if (v <= 3) return 'text-info';
    return 'text-danger';
  }

  public kpiBgClass(kpi: any): string {
    if (kpi == null) return 'kpi-card--neutral';
    const v = kpi * 1;
    if (v <= 1) return 'kpi-card--success';
    if (v <= 3) return 'kpi-card--info';
    return 'kpi-card--danger';
  }
}
